<template>
    <div>
        <div class="form-row">
            <div class="col-sm-6">
                <base-input type="text" label="Nome" required placeholder="Digite seu nome" v-model="value.firstName" v-validate="modelValidations.firstName" data-vv-name="owner.firstName" data-vv-as="nome" maxlength="100" :error="getError('owner.firstName')" />
            </div>
            <div class="col-sm-6">
                <base-input required label="Sobrenome" type="text" placeholder="Digite seu sobrenome" v-model="value.lastName" v-validate="modelValidations.lastName" data-vv-name="owner.lastName" data-vv-as="sobrenome" maxlength="150" :error="getError('owner.lastName')" />
            </div>
        </div>
        <div class="form-row justify-content-start">            
            <div class="col-sm-6">
                <base-input required label="E-mail" type="email" placeholder="Digite seu e-mail" v-model="value.email" v-validate="modelValidations.email" :error="getError('owner.email')" data-vv-name="owner.email" data-vv-as="e-mail do administrador" maxlength="256" />
            </div>
        </div>                        
        <div class="form-row justify-content-start">
            <div class="col-sm-1">
                <div class="form-group">
                    <label for="name">DDD</label>
                    <the-mask type="tel" placeholder="DDD" v-model="value.phone.areaCode" v-validate="modelValidations.areaCode" :class="{'form-control': true, 'is-invalid': errors.has('owner.areaCode')}" data-vv-name="owner.areaCode" data-vv-as="DDD" :mask="['##']" />
                    <div v-show="errors.has('owner.areaCode')" class="invalid-feedback">
                        {{ errors.first('owner.areaCode') }}
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <label for="name">Telefone</label>                                    
                    <the-mask type="tel" placeholder="Digite seu telefone" v-model="value.phone.number" v-validate="modelValidations.phoneNumber" :class="{'form-control': true, 'is-invalid': errors.has('owner.phoneNumber')}" data-vv-name="owner.phoneNumber" data-vv-as="telefone" :mask="['####-####', '#####-####']" />
                    <div v-show="errors.has('owner.phoneNumber')" class="invalid-feedback">
                        {{ errors.first('owner.phoneNumber') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row justify-content-start" v-if="action == 'edit_admin' || action == 'new_admin'">
            <div class="col-sm-2">
                <div class="form-group">
                    <label for="status">Perfil</label>
                    <select :class="{'form-control': true, 'is-invalid': errors.has('role')}" v-validate="modelValidations.role" v-model="value.role" data-vv-name="role" data-vv-as="Perfil">
                        <option v-for="(item, index) in roleList" :key="index" :value="item.id">
                            {{item.name}}
                        </option>
                    </select>                                    
                    <div v-show="errors.has('status')" class="invalid-feedback">
                        {{ errors.first('status') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row" v-if="action == 'edit_admin' || action == 'new_admin'">
            <div class="col-sm-3">
                <div class="form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" v-model="value.blocked" id="blocked">
                        <label class="custom-control-label" for="blocked">Bloqueado?</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'user-input',
    inject: ['$validator'],
    props: {
        value: {
            type: Object,
            default: {
                firstName: '',
                lastName: '',
                email: '',
                phone: {
                    areaCode: '',
                    number: ''
                },
                id: '',
                customerId: '',
                role: '',
                blocked: false
            }
        },
        action: {
            type: String
        }
    },
    data(){
        return {            
            modelValidations: {
                firstName: {
                    required: true,
                    max: 100
                },
                lastName: {
                    required: true,
                    max: 155
                },
                email: {
                    required: true,
                    email: true
                },
                areaCode: {
                    required: true
                },
                phoneNumber: {
                    required: true,
                },
                role: {
                    required: true,
                }
            }
        }
    },
    watch: {
        value() {
            this.$emit('input', this.value);
        }        
    },
    computed: {
        roleList() {
            let roles = [
                {
                    id: '',
                    name: 'Selecione:'
                }]
            
            switch(this.action)
            {
                case 'edit_admin':
                case 'new_admin':
                    roles.push({id: 'Partner',name: 'Administrador'})
                    roles.push({id: 'Backoffice',name: 'Backoffice'})
                    roles.push({id: 'Finance',name: 'Financeiro'})
                    roles.push({id: 'Logistic',name: 'Logistica'})
                    break;
                case 'edit_user':
                case 'new_seller':
                case 'edit_seller':
                    roles.push({id: 'Seller',name: 'Empresa'})
                    break;
                case 'new_salesperson':
                case 'edit_salesperson':
                    roles.push({id: 'Salesperson',name: 'Representante'})
                    break;
            }                        
            return roles
        }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName)
        }
    }
}
</script>